/** Every notification Learn has written for this account, newest first. */

import { notifications as bell } from '../api';
import { Row } from '../components/Bell';
import { Empty, ErrorNote, Loading, OkNote, PageTitle, Panel } from '../components/Chrome';
import { ds } from '../ds';
import { plural } from '../theme';
import { useActions, useLoad } from '../useLoad';

export default function Notifications() {
  const { Button } = ds();
  const { data, error, loading, reload } = useLoad(
    () => bell.list(),
    'Could not load your notifications.'
  );
  const { busy, error: wrote, ok, act } = useActions(reload);

  if (error) return <ErrorNote>{error}</ErrorNote>;
  if (!data) return loading ? <Loading /> : null;

  return (
    <>
      <PageTitle
        title="Notifications."
        meta={data.unread > 0 ? `${data.unread} unread` : plural(data.notifications.length, 'notification')}
      >
        {data.unread > 0 && (
          <Button
            variant="secondary"
            size="sm"
            disabled={busy}
            onClick={() => void act(() => bell.read(), 'Marked as read.')}
          >
            Mark all as read
          </Button>
        )}
      </PageTitle>

      <ErrorNote>{wrote}</ErrorNote>
      <OkNote>{ok}</OkNote>

      {data.notifications.length === 0 ? (
        <Empty line="Nothing yet." />
      ) : (
        <Panel style={{ display: 'grid', gap: 4 }}>
          {data.notifications.map((n) => (
            <Row key={n.id} n={n} />
          ))}
        </Panel>
      )}
    </>
  );
}
